export const errorHandler = (error: any, requestData: any): void => {
  console.log(error);
};
